import { useState } from "react";
import { Box, Button } from "@mui/material";
import { StyledTextfield } from "./StyledTextField";
import { useDispatch } from "react-redux";
import { subscribeEmail } from "../util/api/emailApi";
import { setError } from "../actions/notificationActions";

const EmailField = ({ sx, labelText = "Your Email", buttonText = "Subscribe", onSubmit = () => { } }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [nameError, setNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);

  const dispatch = useDispatch();

  const handleSubmit = () => {
    const nameIsEmpty = name.trim() === "";
    const emailIsEmpty = email.trim() === "";

    setNameError(nameIsEmpty)
    setEmailError(emailIsEmpty)
    if (nameIsEmpty || emailIsEmpty)
      return

    subscribeEmail(email.trim(), name.trim()).then(() => {
      setNameError(false)
      setEmailError(false)
      setName("")
      setEmail("")

      onSubmit()
    }).catch(() => {
      dispatch(setError("Could not subscribe to mailing list."))
    })
  }
  return <Box sx={{ width: { xs: "300px", md: "500px" }, mb: 1, ...sx, flexDirection: "column" }}>
    <StyledTextfield
      label="Your Name"
      placeholder="Enter your name"
      variant="outlined"
      value={name}
      error={nameError}
      required
      fullWidth
      size="small"
      sx={{ mb: 1 }}
      onChange={(e) => { setName(e.target.value) }}
    />
    <Box sx={{ display: "flex", width: "100%" }}>
      <StyledTextfield
        label={labelText}
        type="email"
        placeholder="Enter your email"
        variant="outlined"
        value={email}
        error={emailError}
        required
        size="small"
        onChange={(e) => { setEmail(e.target.value) }}
        InputProps={{
          sx: {
            borderRadius: 0,
          }
        }}
      />
      <Button onClick={handleSubmit} sx={{ padding: "8px 14px", minHeight: "40px", width: "40%", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }} variant="contained">{buttonText}</Button>
    </Box>

  </Box >
}

export default EmailField;
